import { FC } from 'react';

type FullScreenImageProps = {
  src: string;
  alt?: string;
  onClose: () => void;
};

const FullScreenImage: FC<FullScreenImageProps> = ({ src, alt, onClose }) => {
  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70"
      onClick={onClose}
    >
      <div className="relative" onClick={(e) => e.stopPropagation()}>
        <button
          className="absolute -top-4 -right-4 w-9 h-9 rounded-full bg-white flex items-center justify-center shadow-lg z-10 cursor-pointer"
          onClick={onClose}
          aria-label="Close"
        >
          <span className="text-xl font-bold leading-none">&times;</span>
        </button>
        <img
          src={src}
          alt={alt || 'Full screen image'}
          draggable={false}
          className="max-w-[95vw] max-h-[90vh] w-auto h-[90vh] object-contain rounded-lg"
        />
      </div>
    </div>
  );
};

export default FullScreenImage;
